import React from 'react';
import '../templates.css';

/**
 * Bonafide Classic Template
 */
const BonafideClassic = ({ data, schoolInfo }) => {
  const d = data || {};
  const school = schoolInfo || {};
  const formatDate = (dt) => dt ? new Date(dt).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' }) : '';

  return (
    <div className="tpl-page tpl-bonafide-classic">
      <div className="tpl-border">
        <div className="tpl-header">
          {school.schoolLogo && <img src={school.schoolLogo} alt="" className="tpl-logo" />}
          <div className="tpl-header-text">
            <h1 className="tpl-school-name">{school.schoolName || 'School Name'}</h1>
            {school.schoolAddress && <p className="tpl-school-addr" dangerouslySetInnerHTML={{ __html: school.schoolAddress.replace(/<br\s*\/?>/gi, '<br/>') }} />}
            {school.schoolEmail && <p className="tpl-school-addr">{school.schoolEmail}</p>}
          </div>
        </div>
        <div className="tpl-title-bar tpl-title-bar-green"><h2>BONAFIDE CERTIFICATE</h2></div>

        <div className="tpl-cert-meta">
          <span>Certificate No: <strong>{d.Certificate_Number || d.Certificate_Id || '—'}</strong></span>
          <span>Date: <strong>{formatDate(d.Certificate_Date) || formatDate(new Date())}</strong></span>
        </div>

        <div className="tpl-body-text">
          <p>
            This is to certify that <strong>{d.Student_Name || 'XXXXXXXXXX'}</strong>,
            {d.Gender === 'Female' ? ' D/o' : ' S/o'} <strong>{d.Father_Name || 'XXXXXXXXXX'}</strong>
            {d.Mother_Name ? <> and <strong>{d.Mother_Name}</strong></> : null}
            , is a bonafide student of this school, studying in Class <strong>{d.Student_Class || 'XX'}</strong>
            {d.Student_Section ? <>, Section <strong>{d.Student_Section}</strong></> : null}
            {d.Academic_Session ? <> during the academic session <strong>{d.Academic_Session}</strong></> : null}
            .
          </p>
          {d.Admission_Number && (
            <p>His/Her admission number is <strong>{d.Admission_Number}</strong>.</p>
          )}
          {d.Purpose && (
            <p>This certificate is being issued for the purpose of <strong>{d.Purpose}</strong>.</p>
          )}
          {d.Remarks && (
            <p><strong>Remarks:</strong> {d.Remarks}</p>
          )}
        </div>

        <div className="tpl-footer" style={{ marginTop: 60 }}>
          <div className="tpl-footer-date">
            Place: _____________<br />
            Date: {formatDate(d.Certificate_Date) || formatDate(new Date())}
          </div>
          <div className="tpl-signatures">
            <div className="tpl-sig"><div className="tpl-sig-line" /><span>Principal</span></div>
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * Bonafide Modern Template
 */
const BonafideModern = ({ data, schoolInfo }) => {
  const d = data || {};
  const school = schoolInfo || {};
  const formatDate = (dt) => dt ? new Date(dt).toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' }) : '';

  return (
    <div className="tpl-page tpl-bonafide-modern">
      <div className="tpl-mod-header">
        <div className="tpl-mod-header-bar tpl-bar-green" />
        <div className="tpl-mod-header-content">
          {school.schoolLogo && <img src={school.schoolLogo} alt="" className="tpl-logo-sm" />}
          <div>
            <h1 className="tpl-mod-school">{school.schoolName || 'School Name'}</h1>
            {school.schoolAddress && <p className="tpl-mod-addr" dangerouslySetInnerHTML={{ __html: school.schoolAddress.replace(/<br\s*\/?>/gi, '<br/>') }} />}
            {school.schoolEmail && <p className="tpl-mod-addr">{school.schoolEmail}</p>}
          </div>
        </div>
        <div className="tpl-mod-title tpl-title-green">Bonafide Certificate</div>
        <div className="tpl-mod-certno">No: {d.Certificate_Number || d.Certificate_Id || '—'}</div>
      </div>

      <div className="tpl-mod-card">
        <div className="tpl-mod-grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
          <div className="tpl-mod-field"><span className="tpl-mod-label">Student Name</span><span className="tpl-mod-value">{d.Student_Name || '—'}</span></div>
          <div className="tpl-mod-field"><span className="tpl-mod-label">Father's Name</span><span className="tpl-mod-value">{d.Father_Name || '—'}</span></div>
          <div className="tpl-mod-field"><span className="tpl-mod-label">Class & Section</span><span className="tpl-mod-value">{d.Student_Class || '—'} {d.Student_Section || ''}</span></div>
          <div className="tpl-mod-field"><span className="tpl-mod-label">Admission No</span><span className="tpl-mod-value">{d.Admission_Number || '—'}</span></div>
          <div className="tpl-mod-field"><span className="tpl-mod-label">Academic Session</span><span className="tpl-mod-value">{d.Academic_Session || '—'}</span></div>
          <div className="tpl-mod-field"><span className="tpl-mod-label">Purpose</span><span className="tpl-mod-value">{d.Purpose || '—'}</span></div>
        </div>
      </div>

      {d.Remarks && <div className="tpl-mod-remarks"><strong>Remarks:</strong> {d.Remarks}</div>}

      <div className="tpl-mod-footer">
        <span>Date: {formatDate(d.Certificate_Date) || formatDate(new Date())}</span>
        <div className="tpl-mod-sigs">
          <div className="tpl-sig"><div className="tpl-sig-line" /><span>Principal</span></div>
        </div>
      </div>
    </div>
  );
};

export { BonafideClassic, BonafideModern };
